import BrokerFilterPanel from 'src/Admin/components/User/Personas/Brokers';

const Brokers = ({
  onSelectedBrokersLists,
  formFields,
  selectedBrokerData,
}) => {
  const onSelectedBrokersCount = (length) => {
    console.log('BrokersCount', length);
  };

  const onSetAllBrokers = (dataOnAll) => {
    console.log('dataOnAll', dataOnAll);
  };

  const onSelectedBrokers = (brokers) => {
    onSelectedBrokersLists(brokers);
  };

  return (
    <div>
      <h2 className="blob-permission-plan-section-heading mt-4">Brokers</h2>
      <BrokerFilterPanel
        label={'Select Broker'}
        onSelectedBrokersCount={onSelectedBrokersCount}
        onSelectedBrokers={onSelectedBrokers}
        createUserFormData={formFields}
        onSetAllBrokers={onSetAllBrokers}
        selectedBrokerData={selectedBrokerData}
        editAffiliatedRecords={true}
      />
    </div>
  );
};

export default Brokers;
